var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IncentivesCalendar_1;
import { Utils } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
import './incentivesPeriod';
import './incentivesTimeLevel';
const Schema = {
    $id: 'urn:wisepipe-common-data:IncentivesCalendar',
    type: 'object',
    properties: {
        calendarID: { type: 'string', minLength: 1 },
        timeLevels: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:IncentivesTimeLevel' },
            uniqueItemProperties: ['order', 'level']
        },
        periods: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-data:IncentivesPeriod' },
            uniqueItemProperties: ['name']
        },
        lastModified: { type: 'string', format: 'date-time' },
        lastLockedPeriod: { type: 'string', minLength: 1 }
    },
    required: ['calendarID', 'timeLevels', 'periods', 'lastModified']
};
let IncentivesCalendar = IncentivesCalendar_1 = class IncentivesCalendar {
    constructor(calendarID, timeLevels, periods, lastModified, lastLockedPeriod) {
        this.calendarID = calendarID;
        this.timeLevels = timeLevels;
        this.periods = periods;
        this.lastModified = lastModified;
        this.lastLockedPeriod = lastLockedPeriod;
        JSON.validate(this, IncentivesCalendar_1);
    }
    // helper method; figures it out once and caches it
    getLockedPeriod() {
        if (!this.lastLockedPeriod)
            return undefined;
        if (this.lockedPeriod !== undefined)
            return this.lockedPeriod;
        this.lockedPeriod = this.periods.find((period) => period.name === this.lastLockedPeriod);
        return this.lockedPeriod;
    }
    static bufferID(calendarID) {
        return Utils.base64StringToBuffer(calendarID);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], IncentivesCalendar.prototype, "lastModified", void 0);
IncentivesCalendar = IncentivesCalendar_1 = __decorate([
    JsonSchema(Schema)
], IncentivesCalendar);
export { IncentivesCalendar };
//# sourceMappingURL=incentivesCalendar.js.map